import { useContext, useEffect, useState } from 'react'
import { DUPLICATE_UPLOAD_ID_EXTENSION } from '../../../constants'
import { CreationToolsContext } from '../../../manager'
import CreationToolOutputType from '../../../types/output-type'
import CreationToolUserRestriction from '../../../types/user-restriction'
import { CreationToolUploadSource } from '../types'

export function useDuplicatableTypes(
    source: CreationToolUploadSource,
    uploadSources: CreationToolUploadSource[]
): CreationToolOutputType[] {
    const { userRestrictionAccess } = useContext(CreationToolsContext)
    const [duplicatableTypes, setDuplicatableTypes] = useState<CreationToolOutputType[]>([])
    const isStaff = userRestrictionAccess.indexOf(CreationToolUserRestriction.StaffOnly) > -1

    useEffect(() => {
        const uploadIds: string[] = uploadSources.map((src) => src.id)
        const staffTypes: CreationToolOutputType[] = isStaff ? [CreationToolOutputType.Sticker] : []

        // already has duplicate or is a duplicate
        if (source.isDuplicate || uploadIds.indexOf(`${source.id}${DUPLICATE_UPLOAD_ID_EXTENSION}`) > -1) {
            setDuplicatableTypes([])
            return
        }

        // clips can upload as gifs
        if (source.outputType === CreationToolOutputType.Video) {
            setDuplicatableTypes([CreationToolOutputType.Gif, ...staffTypes])
            return
        }

        // gifs where the source has sound can upload as clips
        if (source.outputType === CreationToolOutputType.Gif) {
            if (source.source.hasAudio) {
                setDuplicatableTypes([CreationToolOutputType.Video, ...staffTypes])
            } else {
                setDuplicatableTypes(staffTypes)
            }
            return
        }

        setDuplicatableTypes([])
    }, [source, uploadSources, setDuplicatableTypes, isStaff])

    return duplicatableTypes
}
